export const ADD_SETTING = 'ADD_SETTING'
export const REMOVE_SETTING = 'REMOVE_SETTING'
export const ADD_REFRESH_HANDLER = 'ADD_REFRESH_HANDLER'
